import CustomLinkWithArrow from '@/_application/core/components/commons/custom-link-with-arrow';
import {ProductCard} from '@/_application/modules/products/components/cards/product-card';
import {Product} from '@/_application/modules/products/model/product';
import {Routes} from '@/config/routes';
import {useTranslation} from 'next-i18next';
import {useInterestedProducts} from '@/framework/product';
import {Fragment} from '@kidslabs/mario-nextjs-react-ui-core';

export interface ProductsSuggestionProps {
    interestedProducts?: Product[];
}

function ProductsSuggestion({interestedProducts}: ProductsSuggestionProps) {
    const {t} = useTranslation('common');
    const {data} = useInterestedProducts();
    const products: Product[] = (interestedProducts ?? data?.items ?? []).filter((p): p is Product =>
        Boolean(p && 'sku' in p),
    );
    if (products.length === 0) {
        return null;
    }

    return (
        <Fragment>
            <h2 className="mb-5 text-[22px] font-extrabold leading-[25px] text-primary">
                {t('for-you-products', 'Sản phẩm dành riêng cho bạn')}
            </h2>

            <div className="grid grid-cols-3 gap-5 lg:grid-cols-4 xl:grid-cols-5">
                {products.slice(0, 10).map(product => (
                    <ProductCard product={product} key={product?.sku} />
                ))}
            </div>

            <div className="mt-5 flex w-full items-center justify-center">
                <CustomLinkWithArrow text={t('text-view-all', 'Xem tất cả')} href={Routes.productsSuggestion} />
            </div>
        </Fragment>
    );
}

export default ProductsSuggestion;
